import { RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.billing.root,
    element: loadable(() => import('./pages/BillingPage')),
  },
  {
    path: paths.billing.tab,
    element: loadable(() => import('./pages/BillingPage')),
  },
];
